import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import Offices from '../../features/offices/Offices';
import AuditLogs from '../../features/auditLogs/AuditLogs';
import NotFound from '../../common/components/router/NotFound';

const SettingAppRoutes = () => (
  <Routes>
    <Route
      path="/offices"
      element={
        <PrivateRoute permissions={[PERMISSIONS.SettingRead]}>
          <Offices />
        </PrivateRoute>
      }
    />
    <Route
      path="/auditlogs"
      element={
        <PrivateRoute permissions={[PERMISSIONS.SettingRead]}>
          <AuditLogs />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default SettingAppRoutes;
